
    import Vue from "vue";

    const END_POINT = "/program";

    const getProgram = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllPrograms = data => Vue.axios.get(END_POINT, {params: data});

    const createProgram = (program, locationIds) => {
      const params = locationIds && locationIds.length ? { centerIds: locationIds.join(',') } : {};
      return Vue.axios.post(END_POINT, program, { params });
    };

    const createAllPrograms = Programs => Vue.axios.post(END_POINT + "/all",  Programs );

    const updateProgram = program => Vue.axios.put(END_POINT  + "/" + program.id,  program );

    const deleteProgram = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getProgram,
      getAllPrograms,
      createProgram,
      createAllPrograms,
      updateProgram,
      deleteProgram
    };
    